import { render, staticRenderFns } from "./OrderCheckTable.vue?vue&type=template&id=32cb74ea&"
import script from "./OrderCheckTable.vue?vue&type=script&lang=js&"
export * from "./OrderCheckTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderCheckTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports